import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { INVENTORY } from "@/constants/testIds";

/** Correccion manual de stock (ej: conteo fisico, merma, rotura). */
export default function StockAdjustModal({ open, onOpenChange, product, onSubmit }) {
  const [delta, setDelta] = useState("");
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setDelta("");
      setReason("");
      setError("");
    }
  }, [open]);

  const handleSave = async () => {
    if (!delta || Number(delta) === 0) {
      setError("Ingresa una cantidad distinta de cero (positiva para sumar, negativa para restar)");
      return;
    }
    if (!reason.trim()) {
      setError("Ingresa un motivo para el ajuste");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await onSubmit({ quantity_delta: Number(delta), reason: reason.trim() });
      onOpenChange(false);
    } catch (err) {
      setError(err?.message || "No se pudo ajustar el stock");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={INVENTORY.adjustModal}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Ajustar stock</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <p className="text-sm text-muted-foreground">
            {product?.name} &middot; stock actual: {product?.stock_quantity} {product?.unit}
          </p>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Cantidad (+ suma, - resta)</Label>
            <Input type="number" step="0.01" value={delta} onChange={(e) => setDelta(e.target.value)} data-testid={INVENTORY.adjustModalDeltaInput} placeholder="Ej: -2 o 5" />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Motivo</Label>
            <Input value={reason} onChange={(e) => setReason(e.target.value)} data-testid={INVENTORY.adjustModalReasonInput} placeholder="Ej: Conteo fisico, rotura de vial" />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid={INVENTORY.adjustModalCancelButton}>Cancelar</Button>
          <Button onClick={handleSave} disabled={saving} data-testid={INVENTORY.adjustModalSaveButton}>
            {saving ? "Guardando..." : "Ajustar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
